import React, { Dispatch, SetStateAction, useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
// import { ContinuousReportingType } from "../ContinuousReporting";
// import { createStatementByProjectId } from "lib/api_ts/ReportingApi";
import { useLocation } from 'react-router-dom-v5-compat';
import StatusBar from 'components/StatusBar';
import { createStatementByProjectId } from '@lib/api_ts/continuousReportingApi';

interface ContinuousReportingCreateModalProps {
	isModalOpen: boolean;
	setIsModalOpen: Dispatch<SetStateAction<boolean>>;
	fetchData: () => void;
}

const ContinuousReportingCreateModal: React.FC<ContinuousReportingCreateModalProps> = ({ isModalOpen, setIsModalOpen, fetchData }) => {
	const { pathname } = useLocation();
	const projectId = pathname.split('/')[2];

	const blankReportToCreate = {
		note: '',
	};
	const [reportToCreate, setReportToCreate] =
		// useState<Partial<ContinuousReportingType>>(blankReportToCreate);
		useState<{ note: string }>(blankReportToCreate);
	const resetReportToCreate = () => {
		setReportToCreate(blankReportToCreate);
	};

	const blankStatusBar = {
		status: undefined,
		message: '',
		timeout: undefined,
	};

	const [statusBar, setStatusBar] = useState(blankStatusBar);
	const resetStatusBar = () => {
		setStatusBar(blankStatusBar);
	};

	const handleCreate = async () => {
		setStatusBar({
			status: 'elaborating',
			message: 'Creazione Continuous Reporting in corso',
			timeout: false,
		});
		try {
			await createStatementByProjectId(projectId, {
				statementTypeCode: 'CR',
				note: reportToCreate.note,
			});
			setStatusBar({
				status: 'success',
				message: 'Continuous Reporting creato con successo',
				timeout: true,
			});
			setTimeout(() => {
				setIsModalOpen(false);
				resetStatusBar();
				resetReportToCreate();
				fetchData();
			}, 2000);
			console.log('created', reportToCreate);
		} catch (error) {
			console.error('error', error);
			setStatusBar({
				status: 'error',
				message: 'Errore durante la creazione del Continuous Reporting',
				timeout: true,
			});
			setTimeout(() => {
				resetStatusBar();
			}, 2000);
		}
	};
	return (
		<Modal
			size="lg"
			show={isModalOpen}
			onHide={() => {
				setIsModalOpen(false);
				resetReportToCreate();
				resetStatusBar();
			}}
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title>Nuovo Continuous Reporting</Modal.Title>
			</Modal.Header>
			<Form>
				<Modal.Body>
					<Row className="mb-3" style={{ marginTop: '2rem' }}>
						<Form.Group as={Col} md={6}>
							<Form.Label className="mb-3">Note</Form.Label>
							<Form.Control
								value={reportToCreate.note || ''}
								onChange={(event) => {
									setReportToCreate((prevReportToCreate) => ({
										...prevReportToCreate,
										note: event.target.value,
									}));
								}}
							/>
						</Form.Group>
						{/* <Form.Group as={Col} md={6}>
              <Form.Label className="mb-3">Data Prevista fine</Form.Label>
              <Form.Control
                type="date"
                value={reportToCreate.endDate || ""}
                onChange={(event) => {
                  setReportToCreate((prevReportToCreate) => ({
                    ...prevReportToCreate,
                    endDate: event.target.value,
                  }));
                }}
              />
            </Form.Group> */}
					</Row>
					{statusBar.status ? (
						<StatusBar status={statusBar.status} message={statusBar.message} timeout={statusBar.timeout}>
							<></>
						</StatusBar>
					) : null}
				</Modal.Body>
				<Modal.Footer>
					<Button
						onClick={(event) => {
							event.preventDefault();
							handleCreate();
						}}
					>
						Crea
					</Button>
				</Modal.Footer>
			</Form>
		</Modal>
	);
};

export default ContinuousReportingCreateModal;
